import forge from "node-forge";

export const storage = window.localStorage;
export const STORAGE_KEY = "qz-certificates";

export default (qz) => {
  var appCertificates = null;
  const sessionCerts = storage.getItem(STORAGE_KEY);
  if (sessionCerts) {
    console.log("Carregando chaves do sessionStorage (forge)...");
    appCertificates = JSON.parse(sessionCerts);
  } else {
    console.log("Gerando novo par de chaves e certificado (forge)...");

    // 1. Gerar o Par de Chaves RSA
    var keys = forge.pki.rsa.generateKeyPair({ bits: 2048, e: 0x10001 });

    // 2. Criar o Certificado X.509
    var cert = forge.pki.createCertificate();
    cert.publicKey = keys.publicKey;
    cert.serialNumber = "01"; // Número de série

    // 3. Definir as datas de validade (ex: 1 ano)
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.validity.notAfter.setFullYear(
      cert.validity.notBefore.getFullYear() + 1
    );

    // 4. Preencher os dados do "Assunto" (Subject)
    var attrs = [
      { name: "commonName", value: "TiqOne" },
      { name: "organizationName", value: "TiqOne" },
      { name: "countryName", value: "BR" },
      { name: "stateOrProvinceName", value: "SP" },
      { name: "localityName", value: "Sao Paulo" },
    ];
    cert.setSubject(attrs);
    cert.setIssuer(attrs); // Autoassinado (self-signed)

    // 5. Assinar o certificado com a própria chave privada
    cert.sign(keys.privateKey, forge.md.sha512.create());
    console.log("Certificado gerado com sucesso.");

    // 6. Converter para o formato PEM (texto)
    const pem = forge.pki.certificateToPem(cert); // Este é o certificado
    const privateKeyPem = forge.pki.privateKeyToPem(keys.privateKey);

    // 7. Salvar na sessão
    // O 'pem' (certificado) já está sendo salvo no JSON, como pedido.
    appCertificates = { pem: pem, privateKeyPem: privateKeyPem };

    storage.setItem(STORAGE_KEY, JSON.stringify(appCertificates));
  }

  qz.security.setCertificatePromise(function (resolve, reject) {
    resolve(appCertificates.pem);
  });

  // 10. Fornecer a função de Assinatura
  qz.security.setSignatureAlgorithm("SHA512"); // Corresponde ao forge.md.sha512
  qz.security.setSignaturePromise(function (dataToSign) {
    return function (resolve, reject) {
      try {
        // Carregar a chave privada do formato PEM
        const privateKey = forge.pki.privateKeyFromPem(
          appCertificates.privateKeyPem
        );

        // Criar o "digest" (hash) dos dados
        const md = forge.md.sha512.create();
        md.update(dataToSign, "utf8"); // 'utf8' é importante

        // Assinar o hash
        const signature = privateKey.sign(md);

        // Converter a assinatura para Base64
        const signatureBase64 = forge.util.encode64(signature);

        console.log("Assinatura gerada (forge):", signatureBase64);
        resolve(signatureBase64);
      } catch (err) {
        console.error("Erro ao assinar (forge):", err);
        reject(err);
      }
    };
  });
};
